import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { TrendingUp } from "lucide-react";

export const GuardProfile = () => {
  const { user } = useAuth();
  const [guard, setGuard] = useState(null);
  const [perf, setPerf] = useState(null);

  const load = useCallback(async () => {
    if (!user?.guard_id) return;
    const r = await api.get(`/guards/${user.guard_id}`);
    setGuard(r.data);
    setPerf(r.data.performance);
  }, [user?.guard_id]);

  useEffect(() => { load(); }, [load]);

  if (!guard) return <div className="text-muted">Loading...</div>;

  return (
    <div className="space-y-4">
      <div className="s-card text-center">
        <div style={{ width: 72, height: 72, borderRadius: "50%", margin: "0 auto",
                      background: "rgba(46,202,200,0.15)",
                      display: "flex", alignItems: "center", justifyContent: "center",
                      color: "#2ECAC8", fontSize: 28, fontWeight: 500 }}>
          {guard.full_name[0]}
        </div>
        <div className="h-page mt-3" style={{ fontSize: 19 }}>{guard.full_name}</div>
        <div className="text-muted" style={{ fontSize: 13 }}>{guard.rank} · {guard.department}</div>
        <div className="text-muted mono" style={{ fontSize: 12, marginTop: 6 }}>NIN · {guard.nin}</div>
      </div>

      <div className="s-card">
        <div className="flex items-center gap-2 mb-3">
          <TrendingUp size={16} color="#2ECAC8" />
          <div className="h-section" style={{ fontSize: 15 }}>Performance</div>
        </div>
        <div className="text-center mb-4">
          <div style={{ fontSize: 44, color: "#2ECAC8", fontWeight: 500, lineHeight: 1 }}>{perf?.score || 0}</div>
          <div className="text-muted" style={{ fontSize: 12, marginTop: 4 }}>Composite score · 100</div>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <Stat label="Attendance" value={`${perf?.attendance_pct || 0}%`} />
          <Stat label="Tours done" value={perf?.tours_completed || 0} />
          <Stat label="Reports" value={perf?.reports_submitted || 0} />
          <Stat label="Shifts" value={perf?.shifts_total || 0} />
        </div>
      </div>

      <div className="s-card">
        <div className="h-section mb-2" style={{ fontSize: 15 }}>Skills</div>
        <div className="flex flex-wrap gap-2">
          {(guard.skills || []).map(s => <span key={s} className="badge badge-neutral">{s}</span>)}
        </div>
      </div>
    </div>
  );
};

const Stat = ({ label, value }) => (
  <div className="p-3 rounded-lg" style={{ background: "rgba(46,202,200,0.05)", border: "1px solid var(--border-dark)" }}>
    <div className="text-muted" style={{ fontSize: 11 }}>{label}</div>
    <div style={{ fontSize: 20, color: "#fff", marginTop: 4 }}>{value}</div>
  </div>
);
